import React from 'react'

import type { SimpleHeaderContentBlock } from '@library/api-menu-experience'
import { SimpleHeader } from '@library/menu-page'

type SimpleHeaderContentBlockWrapperProps = {
  contentBlock: SimpleHeaderContentBlock
}

export const SimpleHeaderContentBlockWrapper = ({
  contentBlock,
}: SimpleHeaderContentBlockWrapperProps) => <SimpleHeader contentBlock={contentBlock} />
